export default "__VITE_ASSET__TEloOhJL__"